module.exports = __webpack_public_path__ + "static/media/104eyes.89ddd64b.gif";